module.exports = __webpack_public_path__ + "static/media/verenaVonBomhard.8fe5dcad.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/verenaVonBomhard.jpg
// module id = 1596
// module chunks = 1